module.exports = {"340403001":"田东街道","340403002":"新淮街道","340403003":"国庆街道","340403004":"淮滨街道","340403005":"朝阳街道","340403006":"公园街道","340403007":"洞山街道","340403008":"龙泉街道","340403009":"泉山街道","340403100":"舜耕镇","340403101":"安成镇","340403102":"曹庵镇","340403103":"三和镇","340403201":"史院乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340403.json
// module id = 1067
// module chunks = 0